import React, {useState, useEffect} from "react";
import { Typography,
    Grid,
    TextField as RTextField,
    Button,
    makeStyles,
    Container } from "@material-ui/core";
import {Formik, Form, Field,  ErrorMessage} from "formik";
import {TextField} from "formik-material-ui";
import {colorError} from "../../../Constants/theme";
import * as Yup from "yup";
import { Autocomplete } from "@material-ui/lab";
import {countries, states } from "../../../Constants/locations";
import {RootState, useAppDispatch} from "../../../redux/store";
import {useSelector} from "react-redux";
import {
    addAddress,
    getAddress
} from "../../../redux/userProfile/userProfile.actions";
import {zipCodes} from "../../../Constants/zipcodes";
interface Props {
	changeCount: (number: number) => void;
}

interface Props {
	changeCount: (number: number) => void;
}

const useStyle = makeStyles(() => ({
    body: {
        paddingTop: 20,
    },
    spacing: {
        paddingTop: 20,
    },
    cancelButton: {
        border: `1.5px solid ${colorError}`,
        color: colorError
    },
    hidden: {
        display: "none"
    },
    location: {
        height: 40
    },
    formError: {
        color: colorError,
        fontSize: "12px"
    }
}));

const Address = ({changeCount}: Props) => {
    const classes = useStyle();
    // const [uState, setUState] = useState<null | any>();
    const validationSchema = Yup.object().shape({
        address: Yup.string().required("Required"),
        city: Yup.string().required("Required"),
        state: Yup.object().required("Required"),
        zip: Yup.string().length(5, "Please input a valid 5 digit zipcode").test("match", "Please input a valid 5 digit zipcode", val => {return zipCodes.includes(val);}).required("Required"),
        country: Yup.string().typeError("Required").required("Required")
    });
    const dispatch = useAppDispatch();
    const user = useSelector((state: RootState) => state?.user);
    const [formikValues, setFormikValues] = useState({
        zip: "",
        state: {
            value: "",
            label: ""
        },
        city: "",
        address: "",
        country: "",
    });

    useEffect(() => {
        window.scrollTo(0,0);
        dispatch(getAddress(user.userId))
            .then((address) => {
                let newValues = {...formikValues};
                // let stateName = address?.state || "";
                // setUState(states.filter(item => stateName === item.value)[0])
                newValues.zip = address?.zipCode || "";
                newValues.state = states.find(el => el.value === address?.state) || {label: "Alabama", value: "AL"};
                newValues.city = address?.city || "";
                newValues.address = address?.firstLine || "";
                newValues.country = address?.country || "United States of America";
                setFormikValues({...newValues});
            });
    }, []);

    return (
        <Container className={classes.body} disableGutters={true}>
            <Typography variant="h2" gutterBottom>
                Where are you located?
            </Typography>
            <Formik
                initialValues={formikValues}
                enableReinitialize
                onSubmit={async (values) => {
                    await dispatch(addAddress({
                        userId: user.userId,
                        zipCode: values.zip,
                        state: values.state?.value,
                        city: values.city,
                        firstLine: values.address,
                        country: values.country,
                        defaultAddress: true,
                    }));
                    changeCount(1);
                }}
                validationSchema={validationSchema}
            >
                {({isSubmitting, errors, values, handleChange, setFieldValue}) => (
                    <Form>
                        <Grid container>
                            <Grid item xs={12}>
                                <Typography>
									It’s important we know where you live so that we can create a legal medical record for your pet and match you with a veterinarian licensed in your state when necessary.
                                </Typography>
                            </Grid>
                        </Grid>
                        <Grid container className={classes.spacing}>
                            <Grid xs={12}>
                                <Typography variant="body2">
                                    Address
                                </Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <Field
                                    component={TextField}
                                    id="address"
                                    name="address"
                                    variant="outlined"
                                    label="Address"
                                    fullWidth
                                    multiline
                                    autoComplete="shipping street-address"
                                    color="secondary"
                                    size="medium"
                                    margin="dense"
                                    onChange={handleChange}
                                    value={values.address}
                                    inputProps={{
                                        autoComplete: "shipping street-address",
                                    }}
                                />
                            </Grid>
                            <Grid xs={12}>
                                <Typography variant="body2">
                                    City
                                </Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <Field
                                    component={TextField}
                                    fullWidth
                                    type="text"
                                    autoComplete="shipping address-level2"
                                    id="city"
                                    name="city"
                                    label="City"
                                    value={values.city}
                                    variant="outlined"
                                    color="secondary"
                                    size="medium"
                                    margin="dense"
                                    onChange={handleChange}
                                    inputProps={{
                                        autoComplete: "shipping address-level2",
                                    }}
                                />
                            </Grid>
                            <Grid xs={12}>
                                <Typography variant="body2">
                                    State / Territory <span style={{fontWeight: 400, fontSize: "12px"}}>(2 letter abbreviation)</span>
                                </Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <Autocomplete
                                    fullWidth
                                    options={states}
                                    disableClearable={true}
                                    getOptionLabel={(option) => option.label}
                                    value={values.state}
                                    onChange={(event, value:{label: string, value: string}) => {
                                        setFieldValue("state", value);
                                    }}
                                    renderInput={(params) => <RTextField {...params} margin="dense" variant="outlined" label="State / Territory"/>}
                                />
                                {/*<Field*/}
                                {/*    component={TextField}*/}
                                {/*    fullWidth*/}
                                {/*    type="text"*/}
                                {/*    label="State / Territory"*/}
                                {/*    autoComplete="shipping address-level2"*/}
                                {/*    id="state"*/}
                                {/*    name="state"*/}
                                {/*    value={values.state}*/}
                                {/*    variant="outlined"*/}
                                {/*    color="secondary"*/}
                                {/*    size="medium"*/}
                                {/*    margin="dense"*/}
                                {/*    onChange={handleChange}*/}
                                {/*    inputProps={{*/}
                                {/*        autoComplete: "shipping address-level1",*/}
                                {/*    }}*/}
                                {/*/>*/}
                            </Grid>
                            <Grid xs={12}>
                                <Typography variant="body2">
                                    Zip Code
                                </Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <Field
                                    component={TextField}
                                    fullWidth
                                    type="text"
                                    autoComplete="shipping postal-code"
                                    name="zip"
                                    label="Zip Code"
                                    id="zip"
                                    variant="outlined"
                                    color="secondary"
                                    size="medium"
                                    margin="dense"
                                    onChange={handleChange}
                                    value={values.zip}
                                    inputProps={{
                                        autoComplete: "shipping postal-code",
                                    }}
                                />
                            </Grid>
                            <Grid xs={12}>
                                <Typography variant="body2">
                                    Country / Region
                                </Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <Autocomplete
                                    fullWidth
                                    options={countries}
                                    disableClearable={true}
                                    getOptionLabel={(option) => option}
                                    value={values.country}
                                    onChange={(event, value) => {
                                        setFieldValue("country", value);
                                    }}
                                    renderInput={(params) => <RTextField {...params} margin="dense" variant="outlined" label="Country / Region"/>}
                                />
                                <ErrorMessage name="country">
                                    {msg => <Typography className={classes.formError}>{msg}</Typography>}
                                </ErrorMessage>
                            </Grid>
                        </Grid>
                        <Grid container justify="flex-start" spacing={2} className={classes.spacing}>
                            <Grid item xs={12} sm={3}>
                                <Button
                                    fullWidth
                                    color="secondary"
                                    variant="outlined"
                                    type="submit"
                                    data-testid="submitButton"
                                >
                                    Save
                                </Button>
                            </Grid>
                        </Grid>
                    </Form>
                )}
            </Formik>
        </Container>
    );
};

export default Address;
